import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import useRegistration from '../hooks/useRegistration';
import InvestForm from '../components/sections/InvestForm';
import ConnectWallet from '../components/common/ConnectWallet';
import InlineLoader from '../components/common/InlineLoader';
import Card from '../components/common/Card';

export default function Register() {
  const [params] = useSearchParams();
  const refId = params.get('ref') || '';
  const { account } = useWallet();
  const { loading, registered } = useRegistration();
  const navigate = useNavigate();

  useEffect(() => {
    if (registered) navigate('/dashboard', { replace: true });
  }, [registered, navigate]);

  return (
    <div className="main-content fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title">
            <span className="title-accent">◈</span> Register &amp; Invest
          </h2>
          <div className="page-subtitle">
            {refId ? `Referred by ID #${refId} · ` : ''}
            Complete your first investment to unlock the dashboard
          </div>
        </div>
      </div>

      {!account ? (
        <Card title="Connect Wallet" glow className="form-card">
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div className="text-dim mb-4" style={{ letterSpacing: 1 }}>
              Connect your wallet to register
            </div>
            <ConnectWallet />
          </div>
        </Card>
      ) : loading ? (
        <InlineLoader size="lg" text="Checking account..." />
      ) : (
        <InvestForm
          initialRefId={refId}
          lockRefId={!!refId}
          onSuccess={() => navigate('/dashboard', { replace: true })}
        />
      )}
    </div>
  );
}
